<div class="hts-assistant-composer">
  <div
    class="hts-assistant-composer__field"
    [class.hts-assistant-composer__field--active]="isCanSend"
    [class.hts-assistant-composer__field--disabled]="isDisabled"
  >
    <textarea
      #input
      class="hts-assistant-composer__input"
      rows="1"
      [attr.maxlength]="maxLength"
      [disabled]="isDisabled"
      [placeholder]="placeholderKey | translate"
      (input)="onInput($event)"
      (compositionend)="onCompositionEnd($event)"
      (keydown)="onKeydown($event)"
    ></textarea>
    <button
      type="button"
      class="hts-assistant-composer__send"
      [class.hts-assistant-composer__send--on]="isCanSend"
      [disabled]="!isCanSend"
      [attr.aria-label]="'BUTTON.SEND' | translate"
      (mousedown)="$event.preventDefault()"
      (click)="onSend()"
    >
      <i class="fa fa-paper-plane" aria-hidden="true"></i>
    </button>
  </div>
  <p class="hts-assistant-composer__hint hts-assistant-composer__hint--english" *ngIf="isEnglishOnlyHint" role="status" aria-live="polite">
    {{ "HTS_ASSISTANT.COMPOSER_ENGLISH_ONLY" | translate }}
  </p>
  <p class="hts-assistant-composer__hint" *ngIf="!isTouch && !isEnglishOnlyHint">{{ "HTS_ASSISTANT.COMPOSER_HINT" | translate }}</p>
</div>
